export default {
  setPlantillas(state, p) {
    state.plantillas = p;
  },
  setContratos(state, c) {
    state.contratos = c;
  },
  setContratosNegocio(state, c) {
    state.contratosNegocio = c;
  },
  setContratosRestaurante(state, c) {
    state.contratosRestaurante = c;
  },
  setContratosPartner(state, c) {
    state.contratosPartner = c;
  },
  setContratosDirectorio(state, c) {
    state.setContratosDirectorio = c;
  },
}